(function () {
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function reveal() {
    var els = $$('[data-reveal]:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (c) {
      c.textContent = n; c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump');
    });
  }

  // header: shrink on scroll + mobile menu
  var header = $('[data-header]');
  window.addEventListener('scroll', function () {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 40);
  }, { passive: true });
  document.addEventListener('click', function (e) {
    var st = e.target.closest('[data-sub-toggle]');
    if (st) { st.parentNode.classList.toggle('open'); return; }
    var sb = e.target.closest('[data-search-toggle]');
    if (sb) { var bar = $('[data-searchbar]'); bar.hidden = !bar.hidden; if (!bar.hidden) { var i = $('input[type=search]', bar); if (i) i.focus(); } return; }
    if (e.target.closest('[data-menu-toggle]')) document.body.classList.toggle('menu-open');
    else if (document.body.classList.contains('menu-open') && !e.target.closest('[data-nav]')) document.body.classList.remove('menu-open');
  });

  // collection sort
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort]')) {
      var u = new URL(window.location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page');
      window.location.href = u.toString();
    }
  });

  function initProduct() {
    var root = $('[data-product]'); if (!root || root._ready) return; root._ready = true;
    var form = $('[data-product-form]', root);
    var variants = JSON.parse($('[data-variants]', root).textContent);
    var idInput = $('[data-variant-id]', root), price = $('[data-price]', root), btn = $('[data-add]', root);
    var main = $('#MainImage', root);

    $$('[data-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!main) return; main.style.opacity = 0;
        setTimeout(function () { main.src = b.getAttribute('data-thumb'); main.removeAttribute('srcset'); main.style.opacity = 1; }, 180);
      });
    });

    function sync() {
      var sel = $$('[data-option]', root).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
      if (!sel.length) return;
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      price.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '');
      btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out';
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option]')) sync(); });

    $$('[data-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var q = $('input[name=quantity]', root); q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      });
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; e.preventDefault();
      btn.disabled = true; var label = btn.textContent; btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'Could not add to cart'); return d; }); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (c) { setCount(c.item_count); toast('Added to cart'); })
        .catch(function (err) { toast(err.message); })
        .then(function () { btn.disabled = false; btn.textContent = label; });
    });
  }

  function init() { reveal(); initProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
